// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-title[data-v-ec933d68] {\n  font-size: 24px;\n  font-weight: bold;\n}\n.modal-body[data-v-ec933d68] {\n  overflow-y: visible;\n  height: auto;\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.modal-footer[data-v-ec933d68] {\n  padding-left: 0px;\n  padding-right: 0px;\n  border-top: 0px;\n}\n.modal-footer *[data-v-ec933d68] {\n  margin: 0px;\n}", ""]);
// Exports
module.exports = exports;
